"use strict";

angular.module("customer")
.controller("CatalogInformationController", function($scope, $attrs, close) {
    $scope.catalog = $attrs.catalog;

    this.close = function(confirm) {
        $scope.$element.modal("hide");
        $scope.$element.remove();
    };
});



//////////////////
// WEBPACK FOOTER
// ./customer/app-core/vendors-list/modals/catalog-information.modal.js
// module id = 815
// module chunks = 0